import React, { useState, useContext } from 'react';
import BasicContext from '../BasicContext';
import { List, Accordion, Button } from 'antd-mobile';

import * as Api from "../../../api/usms";
import { Purpose, ReceiptResult, ReceiptResultStyle } from '../utils/const';
import { renderDate, timeFormatType } from '../utils/timeFormat';
import { keyHasPermission, AclKeys } from '../utils/permissions';
import { getCompanyIdByOrgId } from '../utils/common';
import Permission from '../components/Permission';

import moment from 'moment'

import { Loading, Empty, TitleDescriptions } from '../components';
import Filters from './Filters';
import '../index.css';

const defaultFilters = {
  Time: moment(),
};

export default function SendRecords(props) {

  const context = useContext(BasicContext);
  const customerList = context.customers || [];
  const permissions = context.permissions || [];

  const [list, setList] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filters, setFilters] = useState(defaultFilters);
  const [activeKey, setActiveKey] = useState("filter");
  // 翻页参数记录，主要用于上一页翻页
  const [pageParams, setPageParams] = useState([{ FromId: 0 }]);
  const [offset, setOffset] = useState(0);

  // 总条数单独获取
  const [dataTotalCount, setDataTotalCount] = useState(0);
  const [totalCountLoading, setTotalCountLoading] = useState(false);
  const [showTotalCount, setShowTotalCount] = useState(false);
  // const [countryList, setCountryList] = useState([])

  // useEffect(() => {
  //   getAllCountry()
  // }, [])

  const getList = (params, pageParam = {}) => {
    const data = {
      ...params,
      BeginSendTime: moment(params.Time).startOf('day').unix(),
      EndSendTime: moment(params.Time).endOf('day').unix(),
      DomesticFlag: 'Foreign',
      IsIntact: keyHasPermission(AclKeys.SendRecordCompleteContent, permissions),
      Limit: 10,
      Offset: 0
    }
    if (pageParam.FromId) {
      data.FromId = pageParam.FromId
    }
    if (pageParam.EndSendTime) {
      data.EndSendTime = pageParam.EndSendTime
    }

    setLoading(true);
    Api.DescribeQueryRecord(data).then(res => {
      setList(res.Data || []);
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const onFilter = (values) => {
    setFilters(values);
    setActiveKey(); // 收起查询条件
    getList(values, {});
    setShowTotalCount(false);
    setOffset(0);
    setPageParams([{ FromId: 0 }])
  }

  // const getAllCountry = (data) => {
  //   Api.DescribeCountryRegion(data).then(res => {
  //     setCountryList(res)
  //   })
  // }
  // 下一页
  const handleNextPage = () => {
    setOffset(offset + 1)
    if (pageParams.length - 1 === offset) {
      // 翻页的参数
      if (list && list.length > 0) {
        // 下一页通过本页最后一条的id和创建时间做为下一页的筛选条件
        const pageParam = {
          FromId: list[list.length - 1].Id,
          EndSendTime: list[list.length - 1].SendTime
        }
        setPageParams([...pageParams, pageParam]);
        getList(filters, pageParam)
      }
    } else {
      const pageParam = pageParams[offset + 1]
      getList(filters, pageParam)
    }
  }

  const handlePreviousPage = () => {
    setOffset(offset - 1)
    const pageParam = pageParams[offset - 1]
    getList(filters, pageParam)
  }

  const handleGetTotalCount = () => {
    setDataTotalCount(0);
    const data = {
      ...filters,
      BeginSendTime: moment(filters.Time).startOf('day').unix(),
      EndSendTime: moment(filters.Time).endOf('day').unix(),
      Limit: 1,
      Offset: 0,
    }
    setTotalCountLoading(true);
    Api.DescribeSendRecord(data).then(res => {
      setDataTotalCount(res.TotalCount);
      setTotalCountLoading(false);
      setShowTotalCount(true);
    });
  }

  const gotoDetail = (item) => {
    const CompanyId = getCompanyIdByOrgId(customerList, item.OrganizationId);
    window.location.href = `/usms/senddetail?id=${item.SessionId}&sendtime=${item.SendTime}&companyId=${CompanyId}`;
  };

  return (
    <div className="container">
      <Permission aclKey={AclKeys.SendRecord}>
        <Accordion activeKey={activeKey} onChange={key => setActiveKey(key)} className="mb-10">
          <Accordion.Panel header="短信发送记录查询" key="filter">
            <Filters defaultFilters={defaultFilters} onFilter={onFilter} />
          </Accordion.Panel>
        </Accordion>
        <Loading loading={loading} error={errorMessage}>
          {list && (list.length > 0 ?
            <List renderFooter={
              <div style={{ float: 'right', display: 'flex', alignItems: 'center' }}>
                <>
                  {showTotalCount ?
                    <div className="mr-10" style={{ display: 'inline-block' }}>共{dataTotalCount}条</div> :
                    <Button
                      disabled={!list || list.length === 0}
                      className="mr-10"
                      size='small'
                      inline
                      loading={totalCountLoading}
                      onClick={handleGetTotalCount}>{"获取总条数"}</Button>
                  }
                </>
                <Button className="mr-10" inline size='small' disabled={offset === 0} onClick={() => handlePreviousPage()}>{"<<上一页"}</Button>
                <Button inline size='small' disabled={list && list.length < 10} onClick={() => handleNextPage()}>{"下一页>>"}</Button>
              </div>
            }>
              {list.map((item, index) => <List.Item
                arrow="horizontal"
                onClick={() => gotoDetail(item)}
                key={index}
              >
                <TitleDescriptions
                  title={`(${item.CountryCode})${item.Phone}`}
                  descriptions={[
                    item.ChannelId,
                    item.BrevityCode,
                    Purpose[item.Purpose],
                    `${item.ContentLength}/${item.Cost}`,
                    <span className={ReceiptResultStyle[item.ReceiptResult]}>{ReceiptResult[item.ReceiptResult]}</span>,
                    <span>{renderDate(item.SendTime * 1000, timeFormatType.time)}</span>,
                  ]}
                />
              </List.Item>)}
            </List>
            : <Empty />)}
        </Loading>
      </Permission>
    </div>
  )
}